import { Product } from '~/commons/interfaces/models/content/product/Product'
import { getProductRealPrice } from '~/helpers'

export function getProductListingRealPrice(product: Product) {
  return (
    product.calculatedCheapestPrice?.unitPrice || getProductRealPrice(product)
  )
}
